import api from './api'
import type { User } from '@/types'

interface CreateUserPayload {
  email: string
  displayName: string
  role: string
}

interface UpdateUserPayload {
  displayName?: string
  role?: string
  status?: string
}

export const usersService = {
  async list() {
    const { data } = await api.get('/users')
    return data.data as User[]
  },

  async getById(id: string) {
    const { data } = await api.get(`/users/${id}`)
    return data.data as User
  },

  async create(payload: CreateUserPayload) {
    const { data } = await api.post('/users', payload)
    return data.data as { user: User; invitationLink: string }
  },

  async update(id: string, payload: UpdateUserPayload) {
    const { data } = await api.put(`/users/${id}`, payload)
    return data.data as User
  },

  async remove(id: string) {
    await api.delete(`/users/${id}`)
  },

  async resendInvite(id: string) {
    const { data } = await api.post(`/users/${id}/resend-invite`)
    return data.data
  },
}
